import { Page } from "../../containers/content-factory/types"
import { Tab } from "../../containers/content-factory/utils"

export const SET_CF_LAST_ENQUEUED_MESSAGE = "SET_CF_LAST_ENQUEUED_MESSAGE"
export const SET_CF_PAGE = "SET_CF_PAGE"
export const SET_CF_TAB = "SET_CF_TAB"
export const OPEN_CF_PROFILE_READY_DIALOG = "OPEN_CF_PROFILE_READY_DIALOG"
export const DISMISS_CF_PROFILE_READY_DIALOG = "DISMISS_CF_PROFILE_READY_DIALOG"

export type UpdateMessage = { status: string; message: string; datetimeMs: number }

export type SetCfLastEnqueuedMessageAction = {
  type: typeof SET_CF_LAST_ENQUEUED_MESSAGE
  payload: {
    postBatchId: string
    message: UpdateMessage
  }
}

export type SetCfPageAction = {
  type: typeof SET_CF_PAGE
  payload: {
    page: Page | null
    postBatchId: string
  }
}

export type SetCfTabAction = {
  type: typeof SET_CF_TAB
  payload: {
    tab: Tab
  }
}

export type ProfileReadyDialogAction = {
  type: typeof OPEN_CF_PROFILE_READY_DIALOG | typeof DISMISS_CF_PROFILE_READY_DIALOG
  payload: {
    batchId: string
  }
}

export const setCfLastEnqueuedMessage = (
  postBatchId: string,
  message: UpdateMessage
): SetCfLastEnqueuedMessageAction => ({
  type: SET_CF_LAST_ENQUEUED_MESSAGE,
  payload: { postBatchId, message },
})

export const setCfPage = (
  page: Page | null,
  postBatchId: string
): SetCfPageAction => ({
  type: SET_CF_PAGE,
  payload: { page, postBatchId },
})

export const setCfTab = (tab: Tab): SetCfTabAction => ({
  type: SET_CF_TAB,
  payload: { tab },
})

export const openCfProfileReadyDialog = (batchId: string): ProfileReadyDialogAction => ({
  type: OPEN_CF_PROFILE_READY_DIALOG,
  payload: { batchId },
})

export const dismissCfProfileReadyDialog = (batchId: string): ProfileReadyDialogAction => ({
  type: DISMISS_CF_PROFILE_READY_DIALOG,
  payload: { batchId },
})
